import { apiRequest } from '../core';

export function GetProfile(id) {
  const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/profile/${id}`);
  return apiRequest(url);
}